// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1801":"c3a3a6d4","3874":"f61aa71e","4307":"b47a465a","5787":"cca1f6f2","7545":"b47a465a","8512":"66f41516","9757":"b47a465a","9938":"e43c7c41"}[chunkId] + ".chunk.css";
};